var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutubeCircularFilled = function SvgYoutubeCircularFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.575 10.5s-.17-1.205-.695-1.736c-.666-.697-1.412-.7-1.754-.741-2.448-.177-6.122-.177-6.122-.177h-.008s-3.674 0-6.123.177c-.342.04-1.087.044-1.753.741-.525.53-.695 1.737-.695 1.737s-.175 1.416-.175 2.833v1.328c0 1.415.175 2.832.175 2.832s.17 1.205.695 1.736c.666.698 1.54.676 1.93.749 1.4.134 5.95.176 5.95.176s3.677-.006 6.126-.183c.342-.04 1.089-.044 1.754-.742.525-.531.696-1.736.696-1.736s.174-1.417.174-2.833v-1.328c0-1.416-.175-2.832-.175-2.832Zm-10.603 6v-5.377l5.17 2.697-5.17 2.68Z",
    fill: "#fff"
  })));
};

export default SvgYoutubeCircularFilled;